import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { ManageClientComponent } from './manageclient.component';
import { ManageClientService } from './manageclient.service';
import { ManageClientRoutingModule } from './manageclient-routing.module';
import { ValidationService } from '../form-validation/validation.service';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ManageClientRoutingModule,
    SharedModule,
    NgxPaginationModule
  ],
  declarations: [
    ManageClientComponent
  ],
  providers: [ManageClientService, ValidationService]
})
export class ManageClientModule { }

